// extracted by mini-css-extract-plugin
module.exports = {"darkGreyColour":"#3A3A3A","primaryColour":"#09CCC4"};